import { useQuery } from "@tanstack/react-query";
import { LocationControllerApi } from "../../../services";
import { getConfigObject } from "../../../utils/utils";
import { ProviderLocation } from "../../../constants/ProviderLocationFromInitialValues";

interface UseProviderGroupLocationProfileParam {
  locationId: string;
  disable?: boolean;
  xTENANTID?: string;
}

/**
 * query to handle edit provider group profile
 * @author rajkumar rathod
 */
export const useProviderGroupLocationProfile = (
  param: UseProviderGroupLocationProfileParam
) =>
  useQuery({
    queryKey: ["provider-group-location-profile", param],
    queryFn: () => {
      if (param?.disable) return;

      return new LocationControllerApi(getConfigObject())
        .getLocationById(param.locationId, param.xTENANTID)
        .then((res) => res?.data?.data as ProviderLocation);
    },
  });
